// extracted by mini-css-extract-plugin
export default {"AppleButton":"AppleLoginButton_AppleButton__yA1KH"};